// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3FRe7","col":"CardReaderDesc_col__1efR5","label":"CardReaderDesc_label__F03go"};